import { render, staticRenderFns } from "./Supplier.vue?vue&type=template&id=363e7381&scoped=true"
import script from "./Supplier.vue?vue&type=script&lang=js"
export * from "./Supplier.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "363e7381",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('363e7381')) {
      api.createRecord('363e7381', component.options)
    } else {
      api.reload('363e7381', component.options)
    }
    module.hot.accept("./Supplier.vue?vue&type=template&id=363e7381&scoped=true", function () {
      api.rerender('363e7381', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/business/clientManage/coupons/dialogs/ProductConfig/tabItem/Supplier.vue"
export default component.exports